import React, { useState } from "react";
import { AiOutlineDown, AiOutlineClose } from "react-icons/ai";
import AppoinmentModal from "./AppoinmnetModal";

const ServicePremium = () => {
  const [isOpenNutriGenesis, setIsOpenNutriGenesis] = useState(false);
  const [isOpenNutriBioBalance, setIsOpenNutriBioBalance] = useState(false);
  const [isOpenMetaboSync, setIsOpenMetaboSync] = useState(false);
  const [isOpenNutriPrelude, setIsOpenNutriPrelude] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className="pt-80 pb-80 bg-white custom-padding xl-screen-padding">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-6 client-text pb-12">
          Our Premium <span className="text-yellow-600">Health Programs</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-4 relative rounded-lg overflow-hidden">
            <img
              src={require("../../src/assets/images/premium1.png")}
              alt="NutriGenesis Program"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="md:col-span-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 client-text">
              1. NutriGenesis – The Ultimate Precision Nutrition Program (6 Months)
            </h3>
            <p className="text-[#939a9e] text-p mt-4 mb-6">
              Our most advanced and structured program, NutriGenesis, is designed for individuals seeking a cutting-edge, personalised health transformation. This comprehensive program integrates genetic insights with tailored nutrition plans, ongoing monitoring, and expert support.
            </p>
            <button className="bg-button-services common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]" onClick={openModal}
            >
              Contact Us
            </button>
            <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
          </div>
        </div>

        <div className="w-full mx-auto pt-80">
          <div className="w-full bg-[#f2f0ed] p-2 rounded-[30px] shadow-md">
            <button
              className="w-full flex justify-between client-text items-center bg-transparent px-6 py-4 rounded-[30px] text-xl font-semibold"
              onClick={() => setIsOpenNutriGenesis(!isOpenNutriGenesis)}
            >
              Key Features
              {isOpenNutriGenesis ? <AiOutlineClose className="w-5 h-5" /> : <AiOutlineDown className="w-5 h-5" />}
            </button>

            {isOpenNutriGenesis && (
              <div className="mt-0">
                <ul className="text-gray-700 space-y-3 p-6 text-p font-lato">
                  <li className="pb-[12px]">• Dedicated Nutritionist & Program Manager : A committed team ensures your progress is continuously monitored.</li>
                  <li className="pb-[12px]">• Personalised Weekly Nutrition Plans : Adjusted based on your genetic profile, progress, and health goals.</li>
                  <li className="pb-[12px]">• Exclusive Weekly Follow-Ups : One-on-one sessions for tracking improvements and making refinements.</li>
                  <li className="pb-[12px]">• Ongoing Support & Monitoring : Direct access to experts via a dedicated WhatsApp group.</li>
                  <li className="pb-[12px]">• Comprehensive Genetic Testing : Analysis through advanced Nutrigenomics testing (Mandatory).</li>
                  <li className="pb-[12px]">• 5 In-Depth Genetic Counselling Sessions :  40-minute expert consultations to discuss test findings and recommendations.</li>
                  <li className="pb-[12px]">• Pre-Nutrition Counselling : A foundational 4-6 week period to prepare your body for transformation.</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="custom-padding xl-screen-padding bg-white pt-80 pb-80">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 client-text">
              2. NutriBioBalance – Advanced Gut Health Optimization
            </h3>
            <p className="text-[#939a9e] text-p mt-4 mb-6">
              A specialised program designed for individuals looking to optimise gut health and address digestion-related concerns.
            </p>
            <button className="bg-button-services common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]" onClick={openModal}>
              Contact Us
            </button>
            <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />

          </div>

          <div className="md:col-span-4 relative rounded-lg overflow-hidden">
            <img
              src={require("../../src/assets/images/balance1.png")}
              alt="NutriGenesis Program"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="w-full mx-auto pt-80">
          <div className="w-full bg-[#f2f0ed] p-2 rounded-[30px] shadow-md">
            <button
              className="w-full flex justify-between items-center client-text bg-transparent px-6 py-4 rounded-[30px] text-xl font-semibold"
              onClick={() => setIsOpenNutriBioBalance(!isOpenNutriBioBalance)}
            >
              Key Features
              {isOpenNutriBioBalance ? <AiOutlineClose className="w-5 h-5" /> : <AiOutlineDown className="w-5 h-5" />}
            </button>

            {isOpenNutriBioBalance && (
              <div className="mt-0">
                <h1 className="client-text pl-6 font-bold text-[#ca8a04] rounded-md">
                  Includes all NutriGenesis features plus
                </h1>
                <ul className="text-gray-700 space-y-3 p-6 text-p font-lato">
                  <li className="pb-[12px]">• Gut Microbiome Testing : A deep dive into your gut health to enhance digestion and nutrient absorption.</li>
                  <li className="pb-[12px]">• 3 Additional Gut Health Consultations : 40-minute sessions focused on gut-related improvements and strategies.</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="custom-padding xl-screen-padding bg-white pt-80 pb-80">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 client-text">
              3. MetaboSync – Tailored Nutrition for Personalised Wellness
            </h3>
            <p className="text-[#939a9e] text-p mt-4 mb-6">
              For individuals with unique health requirements or those unsure of which plan suits them best, MetaboSync offers an ultra-personalised approach.            </p>
            <button className="bg-button-services common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]" onClick={openModal}>
              Contact Us
            </button>
            <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />

          </div>

          <div className="md:col-span-4 relative rounded-lg overflow-hidden">
            <img
              src={require("../../src/assets/images/balance2.png")}
              alt="NutriGenesis Program"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="w-full mx-auto pt-80">
          <div className="w-full bg-[#f2f0ed] p-2 rounded-[30px] shadow-md">
            <button
              className="w-full flex justify-between items-center client-text bg-transparent px-6 py-4 rounded-[30px] text-xl font-semibold"
              onClick={() => setIsOpenMetaboSync(!isOpenMetaboSync)}
            >
              Key Features
              {isOpenMetaboSync ? <AiOutlineClose className="w-5 h-5" /> : <AiOutlineDown className="w-5 h-5" />}
            </button>

            {isOpenMetaboSync && (
              <div className="mt-0">
                <ul className="text-gray-700 space-y-3 p-6 text-p font-lato">
                  <li className="pb-[12px]">• Flexible Duration : Choose from daily, weekly, or extended plans tailored to your needs.</li>
                  <li className="pb-[12px]">• Comprehensive Personalisation : More intensive support with enhanced health tracking.</li>
                  <li className="pb-[12px]">• Bespoke Nutrition Strategy : Designed to align with your lifestyle and long-term wellness goals.</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="custom-padding xl-screen-padding bg-white pt-80 pb-80">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 client-text">
              4. NutriPrelude – Your Nutritional Foundation
            </h3>
            <p className="text-[#939a9e] text-p mt-4 mb-6">
              Perfect for those new to personalised nutrition, NutriPrelude introduces you to our data-driven approach.
            </p>
            <button className="bg-button-services common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]" onClick={openModal}>
              Contact Us
            </button>
            <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />

          </div>

          <div className="md:col-span-4 relative rounded-lg overflow-hidden">
            <img
              src={require("../../src/assets/images/balance3.png")}
              alt="NutriGenesis Program"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="w-full mx-auto pt-80">
          <div className="w-full bg-[#f2f0ed] p-2 rounded-[30px] shadow-md">
            <button
              className="w-full flex justify-between items-center client-text bg-transparent px-6 py-4 rounded-[30px] text-xl font-semibold"
              onClick={() => setIsOpenNutriPrelude(!isOpenNutriPrelude)}
            >
              Key Features
              {isOpenNutriPrelude ? <AiOutlineClose className="w-5 h-5" /> : <AiOutlineDown className="w-5 h-5" />}
            </button>

            {isOpenNutriPrelude && (
              <div className="mt-0">
                <ul className="text-gray-700 space-y-3 p-6 text-p font-lato">
                  <li className="pb-[12px]">• Initial Consultation : A 30-minute telephonic or virtual session to discuss your health goals.</li>
                  <li className="pb-[12px]">• Preliminary Health Assessment : Data collection and analysis for an insightful overview.</li>
                  <li className="pb-[12px]">• One-Time Nutritional Prescription : Expert guidance to help you choose the best program for your needs.</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicePremium;
